import { computed, ref } from '@vue/composition-api';
import store from '@/store';
import { state as user } from './user';

const duplicateSampleMenu = ref(false);
const notificationsMenu = ref(false);
// const datasetEditingMenu = ref(false);
const isAdmin = computed(() => store.state.client?.user?.user_level === 0);

export { duplicateSampleMenu, notificationsMenu, isAdmin, user };
